import { CertificateSearch } from './CertificateSearch';

const boot = (): void => {
    if (!window.zfp_cert_app_urls) {
        // No plugin instance on the page (or List.html script block not yet rendered).
        return;
    }
    new CertificateSearch();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
